// extracted by mini-css-extract-plugin
var _1 = "PlainCounterStyle-module__base___ItEwn";
var _2 = "PlainCounterStyle-module__plain-counter___n9ALg";
var _3 = "PlainCounterStyle-module__plain-counter___n9ALg";
export { _1 as "base", _2 as "plain-counter", _3 as "plainCounter" }
